
import React, { useState, useEffect } from 'react';
import {useParams,Link} from "react-router-dom"

import ShareButtons from "../components/ShareButtons"
import LatestArticles from "../components/LatestArticles"
import ReadingTime from "../components/ReadingTime"
import {Helmet} from "react-helmet"
import { EyeIcon } from 'lucide-react';



export default function PostDetail(){
    const [visibleSections, setVisibleSections] = useState(new Set());

    const {slug} = useParams()
    const [post,setPost] = useState(null)
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("id-ID", {
            day: "numeric",
            month: "long",
            year: "numeric"
        });
    };
    useEffect(()=>{
        fetch(process.env.REACT_APP_BASE_URL+"/api/events/"+slug)
            .then(res=>res.json())
            .then(data=>setPost(data))
        },
    [slug])

    if(!post){
        return <div className="p-10 text-center">Loading...</div>
    }
    
    return(
        <div className="min-h-screen bg-slate-400/95  text-white  pt-20">
            <Helmet>
                <title>{post.title}</title>
                <script type="application/ld+json">
                    {`
                        {
                            "@context":"https://schema.org",
                            "@type":"Article",
                            "headline":"${post.title}",
                            "datePublished":"${post.created_at}",
                            "image":"${process.env.REACT_APP_BASE_URL}uploads/images/${post.image}"
                        }
                    `}
                </script>
            </Helmet>
            <section 
                data-section="header"
                className="relative
                h-[32vh] md:h-[40vh] lg:h-[45vh]
                overflow-hidden
                flex items-center justify-center
                bg-white"
            >
                <div className="absolute inset-0">
                <img
                    src={`${process.env.REACT_APP_BASE_URL}uploads/images/${post.image}`}
                    alt="background"
                    className="w-full h-full object-cover opacity-40"
                />
                <div className="absolute inset-0 bg-slate-950/60"></div>

                {/* Gradient Glow */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-white"></div>

                {/* Optional Glow Accent */}
                <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-500/20 blur-[120px] rounded-full"></div>
                <div className="absolute bottom-1/4 right-1/3 w-72 h-72 bg-red-500/20 blur-[120px] rounded-full"></div>
                </div>        

                <div className={`
                    relative z-10
                    px-6
                    text-center
                    max-w-5xl
                    mx-auto
                    translate-y-[2vh]
                    transition-all duration-1000 opacity-100
                `}>
                <h1 className="
                    font-bricolage
                    font-bold
                    tracking-tight
                    leading-tight
                    mb-4
                    bg-gradient-to-r
                    from-red-400 via-white to-blue-800
                    bg-clip-text text-transparent
                    text-[clamp(2rem,6vw,4.5rem)]">
                    {post.category === "1"
                            ? "Artikel"
                            : post.category === "2"
                            ? "Blog"
                            : post.category === "3"
                            ? "News"
                            : post.category === "4"
                            ? "Event"
                            : "Lainnya"
                        } Kenzie Komunika
                </h1>
                <div className="w-16 md:w-24 h-1 rounded-full bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-5"></div>
                
                </div>
            </section>
            
            <section 
                data-section="projects"
                className="py-16 bg-white"
            >
                <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 `}>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* MAIN ARTICLE */}
                        <div className="lg:col-span-2">
                            <p className="text-sm text-gray-500 mb-4 ">
                                <span className='px-4 py-2 text-xs rounded-full border border-blue-400/30 bg-blue-400/10 text-blue-300'>
                                    {post.category === "1"
                                        ? "Artikel"
                                        : post.category === "2"
                                        ? "Blog"
                                        : post.category === "3"
                                        ? "News"
                                        : post.category === "4"
                                        ? "Event"
                                        : "Lainnya"
                                    }

                                </span>
                            </p>
                            <h1 className="text-4xl font-bold mb-4 text-slate-700">
                                {post.title}
                            </h1>
                            <div className="flex gap-4 text-sm text-gray-500 mb-6">
                                <span>
                                    {formatDate(post.created_at)}
                                </span>
                                <span className="flex items-center gap-2">
                                    <EyeIcon size={14}></EyeIcon>{post.views ?? 0}
                                </span>
                                <ReadingTime content={post.description}/>
                            </div>
                            <img
                                src={`${process.env.REACT_APP_BASE_URL}uploads/images/${post.image}`}
                                className="rounded-2xl mb-4 transform hover:scale-105 transition-all duration-300"
                            />

                            <div
                                className="prose lg:prose-lg max-w-none text-slate-700"
                                dangerouslySetInnerHTML={{__html:post.description}}
                                >
                            </div>
                            <div className="mt-6 text-blue-600">
                                {post.hashtag}
                            </div>
                        </div>

                        {/* SIDEBAR */}
                        <div>
                            <LatestArticles/>                            
                            <ShareButtons title={post.title} category={post.category} ig_link={post.ig_link} fb_link={post.fb_link} tiktok_link={post.tiktok_link}/>
                        </div>
                    </div>
                </div>
            </section>
            <section 
                data-section="cta"
                className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
                >
                <div className="absolute inset-0">
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
                </div>
        
                <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all `}>
                    <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
                    Ayo bergabung menjadi mitra Kami!
                    </h2>
                    <p className="text-xl text-gray-400 mb-8">
                    Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
                    </p>
                    <Link 
                    to="/contact"
                    className="inline-block px-10 py-4 bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
                    >
                    Mulai mendaftar
                    </Link>
                </div>
            </section>
        </div>
    )

}